import React from "react";
import { Component } from "react";
import { actions } from "react-redux-form";

import store from "../../../store";

export class CheckBox extends Component {
    render(){
        const {classWrapper, isRequired, checked, handleOnChange, disabled } = this.props;
        return(
            <div className={`checkbox-container ${classWrapper ? classWrapper : ""}`}>
                <input type="checkbox" className="custom-checkbox" disabled={disabled} checked={checked} onChange={handleOnChange ? handleOnChange : null}  />
                {isRequired && <span className="required">*</span>}
                <span>{this.props.label}</span>
            </div>
        )
    }
}

export class ControlCheckBox extends Component {
    handleChange(e) {
        var checked = e.target.checked;
        store.dispatch(actions.change(this.props.model, checked));
    }

    render() {
        const { checked, label, classWrapper, isRequired } = this.props;
        return (
            <div className={`checkbox-container ${classWrapper ? classWrapper : ""}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={this.handleChange.bind(this)}
                />
                {isRequired && <span className="required">*</span>}
                <span>{label}</span>
            </div>
        )
    }
}